/* jshint esversion: 6 */
/* globals require */
(function (angular) {
    'use strict';

    const constants = require('@utils/_constants');
    /*
        Gets the main angular module of the project
    */
    var app = angular.module('enervee');

    /*
        Configures routing
    */
    app.config([
        '$stateProvider',
        '$urlRouterProvider',
        '$urlMatcherFactoryProvider',
        '$locationProvider',
        'SITESETTINGS',
        'SETTINGS',
        function (
            $stateProvider,
            $urlRouterProvider,
            $urlMatcherFactoryProvider,
            $locationProvider,
            SITESETTINGS,
            SETTINGS
        ) {
            /**
             * Tracking params are typed as 'any' to prevent router from encoding '/' to '~2F',
             * which could cause an infinite redirect loop in some situations
             */
            const UTM_TRACKING_PARAMETERS = '{utm_source:any}&{utm_medium:any}&{utm_campaign:any}&{utm_term:any}&{utm_content:any}&{cuId:any}';

            /**
             * Case-insensitive URLs
             */
            $urlMatcherFactoryProvider.caseInsensitive(true);

            /**
             * Remove the hash # from URLs
             * https://docs.angularjs.org/error/$location/nobase
             * https://github.com/angular-ui/ui-router/wiki/
             * Frequently-Asked-Questions#how-to-configure-your-server-to-work-with-html5mode
            */
            $locationProvider.html5Mode(true);

            /**
             * Redirect category pages to the same url with a slash at the end
             */
            $urlRouterProvider.when('/:category_code?sortedBy&filters&guide&' + UTM_TRACKING_PARAMETERS,
                ['$match', '$state', function ($match, $state) {
                if ($match.category_code === '') {
                    // Index page gets matched by this pattern, so this lets the request pass
                    return false;
                } else {
                    // Handles anything that could be a category page (or flat page)
                    $state.transitionTo('results', $match, false);
                    return true;
                }
            }]);

            /*
                Load either indexView.html or indexAltView.html based on a
                Wagtail setting and whether or not a categoryId is specified in
                query params
             */
            indexTemplateProvider.$inject = ['$stateParams', '$templateRequest', 'HeaderService'];
            function indexTemplateProvider($stateParams, $templateRequest, HeaderService) {
                return import(/* webpackChunkName: 'index' */ '@app/pages/index/indexTemplates').then(function (indexTemplates) {
                    return HeaderService.getWagtailIndexSettings()
                    .then(function (settings) {
                        // If fetching the Wagtail settings succeeds, conditionally select the template
                        if (Object.keys(indexTemplates).indexOf(settings.alternate_index_page) > -1) {
                            return indexTemplates[settings.alternate_index_page];
                        }
                        return indexTemplates.defaultTemplate;
                    }, function () {
                        // If fetching the Wagtail settings fails, just use the default template
                        console.log('Loading default index template...');
                        return indexTemplates.defaultTemplate;
                    });
                });
            }

            lazyLoadOtherModule.$inject = ['$q', '$ocLazyLoad'];
            function lazyLoadOtherModule($q, $ocLazyLoad) {
                if ($ocLazyLoad.isLoaded('enervee.other')) return $q.resolve();
                $ocLazyLoad.toggleWatch(true);
                return import(/* webpackChunkName: 'other' */ '@app/other/otherModule')
                    .then(function (mod) {
                        return $ocLazyLoad.inject(mod.name).then(function () {
                            $ocLazyLoad.toggleWatch(false);
                        }, function (err) {
                            console.error(`$ocLazyLoad Error: ${err}`);
                            throw err;
                        });
                    })
                    .catch(err => {
                        console.error(`Module Import Error: ${err}`);
                        throw err;
                    });
            }

            var resolveOtherModule = {
                lazyLoad: lazyLoadOtherModule,
            };

            /*
                conditional suites to enable certain urls based on enabled features
            */
            if (SITESETTINGS.active_account_sections.indexOf('orders') > -1) {
                $stateProvider.state('my-orders', {
                    url: '/account/my-orders/',
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'other' */ '@app/components/account/accountOrders/accountOrdersView.html').then(t => t.default);
                    },
                    controller: 'AccountOrdersCtrl',
                    controllerAs: 'AccountOrdersCtrl',
                    data: {
                        pageType: 'accountPage',
                    },
                    resolve: {
                        lazyLoad: lazyLoadOtherModule,
                    }
                }).state('order-summary', {
                    url: `/order-summary/?${UTM_TRACKING_PARAMETERS}`,
                    templateProvider: () => {
                        return import('@app/pages/cart/orderSummary/orderSummaryView.html').then(t => t.default);
                    },
                    controller: 'OrderSummaryCtrl',
                    controllerAs: 'OrderSummaryCtrl',
                    data: {
                        pageType: 'nextBestAction',
                    },
                    resolve: {
                        lazyLoad: ['$ocLazyLoad', $ocLazyLoad => {
                            return import(/* webpackChunkName: 'index' */ '@app/pages/cart/orderSummary/orderSummaryModule')
                                .then(mod => {
                                    return $ocLazyLoad.inject(mod.name);
                                })
                                .catch(err => {
                                    throw new Error(`Module Import Error: ${err}`);
                                });
                        }],
                    }
                });
            }

            if (SITESETTINGS.active_account_sections.indexOf('rebates') > -1) {
                $stateProvider.state('my-rebates', {
                    url: '/account/my-rebates/',
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'other' */ '@app/components/account/accountRebates/accountRebatesView.html').then(t => t.default);
                    },
                    controller: 'AccountRebatesCtrl',
                    controllerAs: 'AccountRebatesCtrl',
                    data: {
                        pageType: 'accountPage',
                    },
                    resolve: {
                        lazyLoad: lazyLoadOtherModule,
                    }
                }).state('claim-summary', {
                    url: `/claim-summary/?${UTM_TRACKING_PARAMETERS}`,
                    templateProvider: () => {
                        return import('@app/components/fastTrack/claimSummary/claimSummaryView.html').then(t => t.default);
                    },
                    controller: 'ClaimSummaryCtrl',
                    controllerAs: 'ClaimSummaryCtrl',
                    data: {
                        pageType: 'nextBestAction'
                    },
                    resolve: {
                        lazyLoad: ['$ocLazyLoad', $ocLazyLoad => {
                            return import(/* webpackChunkName: 'index' */ '@app/components/fastTrack/claimSummary/claimSummaryModule')
                                .then(mod => {
                                    return $ocLazyLoad.inject(mod.name);
                                })
                                .catch(err => {
                                    throw new Error(`Module Import Error: ${err}`);
                                });
                        }],
                    }
                });
            }

            if (SITESETTINGS.enabled_features.indexOf('pick_my_solar') > -1) {
                $stateProvider.state('my-projects', {
                    url: '/account/my-projects/',
                    controller: ['$state', '$timeout', 'SolarService', function ($state, $timeout, SolarService) {
                        $state.go('account').then(() => {
                            SolarService.goToSolar(SolarService.mySolarLocation, null, false);
                        });
                     }],
                    data: {
                        pageType: 'accountPage',
                    },
                    resolve: {
                        lazyLoad: lazyLoadOtherModule,
                    }
                });
            }

            if (SITESETTINGS.enabled_features.indexOf('reamaze_support_page') > -1) {
                $stateProvider.state('support-page', {
                    url: '/support/',
                    template: require('@app/components/support/supportPageView.html'),
                    controller: 'SupportPageCtrl',
                    controllerAs: 'SupportPageCtrl'
                });
            }

            if (SITESETTINGS.enabled_features.indexOf('privacy_tools') > -1) {
                const commonStateConfig = {
                    template: require('@utils/privacyTools/privacyToolsView.html'),
                    controller: require('@utils/privacyTools/privacyToolsController.js'),
                    controllerAs: 'PrivacyToolsCtrl',
                };
                $stateProvider.state('privacy-tools', {
                    url: '/privacy-tools/',
                    resolve: {
                        iframeSrcKey: () => 'submit',
                    },
                    ...commonStateConfig,
                }).state('privacy-tools-verify', {
                    url: '/privacy-tools/verify/:referenceId/:token/',
                    resolve: {
                        iframeSrcKey: () => 'verify',
                    },
                    ...commonStateConfig,
                }).state('privacy-tools-download', {
                    url: '/privacy-tools/download/:referenceId/:token/',
                    resolve: {
                        iframeSrcKey: () => 'download',
                    },
                    ...commonStateConfig,
                });
            }

            if (SITESETTINGS.enabled_features.indexOf('fast_track_with_rrapi') > -1) {
                $stateProvider.state('rebate-fast-track', {
                    url: '/rebate-fast-track/',
                    controller: ['$state', 'FastTrackModalService', function ($state, FastTrackModalService) {
                        $state.go('index').then(function () {
                            FastTrackModalService.showFastTrackModal('rebate-fast-track');
                        });
                    }],
                });
            }

            if (SITESETTINGS.enabled_features.includes('special_offers_page')) {
                $stateProvider.state('special-offers', {
                    url: '/special-offers/',
                    template: require('@utils/specialOffers/specialOffersView.html'),
                    controller: 'SpecialOffersCtrl',
                    controllerAs: 'SpecialOffersCtrl'
                });
            }

            var getActiveCategory = function (CategoriesService) {
                return CategoriesService.afterInitialCategoriesLoads().then(function () {
                    return CategoriesService.getCategories();
                }).then(function (categories) {
                   return categories.find(category => category.is_active === true) || null;
                });
            };

            var getTranslatedSortCodes = function ($q, CmsContentService, UtilService, activeCategory) {
                var defer = $q.defer();
                var SORT_BY_OPTIONS = UtilService.getSiteSetting('sort_by_options');
                var sortOptions = {},
                sortOptionPromises = [],
                promise = null;
                CmsContentService.retrieveCMSContent('sort_by');
                promise = CmsContentService.getMarketPlaceText('sort_by:url_text').then(function (text){
                    sortOptions.sort_by_text = text.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
                        return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
                    }).replace(/\s+/g, '');
                });
                sortOptionPromises.push(promise);
                Object.keys(SORT_BY_OPTIONS.choices).forEach(function (sort_option){
                    var translated_code = '';
                    if (sort_option[0] === '-'){
                        sort_option = sort_option.substr(1);
                        translated_code = '-';
                    }
                    promise = CmsContentService.getMarketPlaceText('sort_by:' + sort_option).then(function (text){
                        sort_option = translated_code + sort_option;
                        translated_code += text.toLowerCase().replace(new RegExp(' ', 'g'), '_').replace(new RegExp("'", "g"), "");
                        sortOptions[translated_code] = sort_option;
                        if (sort_option === activeCategory.default_sort) {
                            sortOptions.default = translated_code;
                        }
                    });
                    sortOptionPromises.push(promise);
                });

                $q.all(sortOptionPromises).then(function () {
                    defer.resolve(sortOptions);
                });

                return defer.promise;
            };

            /**
             * Set validation bypass cookie if that query param exists and then removes query param.
             */
            const setClaimValidationBypassCookie = function ($location, CookiesService) {
                const CODE_QUERY_PARAM = constants.CLAIM_VALIDATION_BYPASS_CODE;
                const claimValidationBypassCode = $location.search()[CODE_QUERY_PARAM];
                if (claimValidationBypassCode) {
                    // Create expiration time and set cookie
                    const DAYS_UNTIL_EXPIRATION = 7;
                    const expires = CookiesService.getExpirationDate({ days: DAYS_UNTIL_EXPIRATION });
                    CookiesService.set(CODE_QUERY_PARAM, claimValidationBypassCode, { expires });
                    // Remove query param
                    $location.search(CODE_QUERY_PARAM, null);
                };
            };

            /**
             * Set up the names of the query params for filters and sortBy
             */
            var resultsQueryParams = '';
            var sortByParam = '';
            var buildQueryParams = function () {
                var languageCode = SETTINGS.languageCode;
                var paramsNames = constants.RESULTS_QUERY_PARAMS[languageCode] || constants.RESULTS_QUERY_PARAMS.en_EN;
                sortByParam = '?' + paramsNames.sortByParamName;
                resultsQueryParams = sortByParam + paramsNames.resultsParams;
            };
            buildQueryParams();

            /*
                if default or / IS hit, go to the index page and use IndexCtrl controller inside indexView.html template as IndexCtrl
                main urls shared across all sites
            */
            $stateProvider
                .state('404', {
                    url: '/error/',
                    template: require('@app/shared/errorPages/404.html'),
                    controller: 'ErrorPagesCtrl',
                    controllerAs: 'ErrorPagesCtrl'
                })
                .state('index', {
                    url: '/?categoryId&claimValidationBypassCode',
                    templateProvider: indexTemplateProvider,
                    controller: 'IndexCtrl',
                    controllerAs: 'IndexCtrl',
                    data: {
                        pageType: 'indexPage',
                    },
                    resolve: {
                        activeCategory: ['CategoriesService', getActiveCategory],
                        claimValidationBypassCookie: ['$location', 'CookiesService', setClaimValidationBypassCookie],
                        lazyLoad: ['$ocLazyLoad', function ($ocLazyLoad) {
                            return import(/* webpackChunkName: 'index' */ '@app/pages/index/indexModule')
                                .then(function (mod) {
                                    return $ocLazyLoad.inject(mod.name);
                                })
                                .catch(function (err) {
                                    throw new Error(`Module Import Error: ${err}`);
                                });
                        }],
                    }
                }).state('results', {
                    url: '/:category_code/' + resultsQueryParams + '&' + UTM_TRACKING_PARAMETERS,
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'results' */ '@app/pages/results/resultsView.html').then(t => t.default);
                    },
                    controller: 'ResultsCtrl',
                    controllerAs: 'ResultsCtrl',
                    data: {
                        filtered: false,
                        sorted: false,
                        pageType: 'categoryPage',
                    },
                    params: {
                        source: null
                    },
                    resolve: {
                        activeCategory: ['$q', '$location', '$state', '$stateParams', 'CategoriesService', 'FiltersService',
                            function ($q, $location, $state, $stateParams, CategoriesService, FiltersService) {
                                var defer = $q.defer();
                                CategoriesService.afterInitialCategoriesLoads().then(function () {
                                    var categoryId = CategoriesService.getCategoryIdByCode($stateParams.category_code);

                                    if (categoryId === undefined) {
                                        let hash = $location.hash();
                                        let search =  $location.search();
                                        let params = {
                                            path: $stateParams.category_code,
                                        };
                                        angular.extend(params, search);

                                        if (hash) {
                                            params.section = hash;
                                        }
                                        defer.reject({ redirectTo: 'flat-pages', params: params });
                                    } else {
                                        CategoriesService.setActiveCategory(categoryId);
                                        if (FiltersService.activeCategory === null || FiltersService.activeCategory.id !== categoryId) {
                                            FiltersService.activateCategory();
                                        }
                                        defer.resolve(CategoriesService.getActiveCategory());
                                    }
                                });
                                return defer.promise;
                            }
                        ],
                        /**
                         * Gets translated sort options
                         */
                        translatedSortCodes: ['$q', 'CmsContentService', 'UtilService', 'activeCategory', getTranslatedSortCodes],
                        translatedFilterCodes: ['$q', '$stateParams', 'FiltersService',
                            function ($q, $stateParams, FiltersService) {
                                var defer = $q.defer();

                                var filtersToTranslate = [
                                    'text',
                                    'brand',
                                    'min-price',
                                    'max-price',
                                    'has_rebate',
                                    'query',
                                    'price'
                                ];

                                FiltersService.getTranslatedFilterCodes(filtersToTranslate).then(function (codes){
                                    defer.resolve(codes);
                                });

                                return defer.promise;
                            }
                        ],

                        /**
                         * Initializes saved searches
                         */
                        mySearches: ['SavedSearchesService',
                            function (SavedSearchesService) {
                                return SavedSearchesService.fetchSavedSearches().then(function () {
                                    return SavedSearchesService.getSavedSearches();
                                });
                            }
                        ],
                        lazyLoad: ['$ocLazyLoad', function ($ocLazyLoad) {
                            return import(/* webpackChunkName: 'results' */ '@app/pages/results/resultsModule')
                                .then(function (mod) {
                                    return $ocLazyLoad.inject(mod.name);
                                })
                                .catch(function (err) {
                                    throw new Error(`Module Import Error: ${err}`);
                                });
                        }]
                    }
                }).state('results.filtered', {
                    data: {
                        filtered: true,
                        sorted: false,
                    },
                    params: {
                        source: 'results'
                    }
                }).state('results.sorted', {
                    data: {
                        filtered: false,
                        sorted: true,
                    },
                    params: {
                        source: 'results'
                    }
                }).state('product', {
                    /**
                     *  This is the main entry point for the product detail pages. From this parent state
                     *  the ProductCtrlRouter will route the user to one of it's child states,
                     *  base or simplified.
                     *
                     *  The logic which controls which child state to go to is located at
                     *  ProductCtrlRouter, lines 64-74
                     */
                    url: '/:category_code/{product_info:[0-9].+}/?email&userId&signupModal&' + UTM_TRACKING_PARAMETERS,
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'product' */ '@app/pages/product/productViewRouter.html').then(t => t.default);
                    },
                    controller: 'ProductCtrlRouter',
                    controllerAs: 'ProductCtrlRouter',
                    data: {
                        pageType: 'productPage',
                        productDetailData: {},
                    },
                    // Gets the initial product detail data and injects it into its controller
                    resolve: {
                        sortBy: ['$state', function ($state) {
                            return $state.params.sortBy;
                        }],
                        sectionParam : ['$location', function ($location) {
                            return $location.search().section;
                        }],
                        activeCategory: ['$q', '$stateParams', 'CategoriesService',
                            function ($q, $stateParams, CategoriesService) {
                                var defer = $q.defer();
                                CategoriesService.afterInitialCategoriesLoads().then(function () {
                                    var categoryId = CategoriesService.getCategoryIdByCode($stateParams.category_code);

                                    if (categoryId === undefined) {
                                        defer.reject({
                                            redirectTo: '404'
                                        });
                                    } else {
                                        CategoriesService.setActiveCategory(categoryId);
                                        defer.resolve(CategoriesService.getActiveCategory());
                                    }
                                });
                                return defer.promise;
                            }
                        ],
                        lazyLoad: ['$ocLazyLoad', function ($ocLazyLoad) {
                            return import(/* webpackChunkName: 'product' */ '@app/pages/product/productModule')
                                .then(function (mod) {
                                    return $ocLazyLoad.inject(mod.name);
                                })
                                .catch(function (err) {
                                    throw new Error(`Module Import Error: ${err}`);
                                });
                        }],
                    }
                }).state('product.base', {
                    /**
                     * This is the route for the base (read: normal) product view, same one you
                     * know and love.
                     */
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'product' */ '@app/pages/product/productViews/baseProductView.html').then(t => t.default);
                    },
                    controller: 'BaseProductCtrl',
                    controllerAs: 'ProductCtrl'
                }).state('product.simplified', {
                    /**
                     * This is the route for the new simplified product view, which is slimmed down
                     * substantially for a less involved product page
                     */
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'product' */ '@app/pages/product/productViews/simplifiedProductView.html').then(t => t.default);
                    },
                    controller: 'SimplifiedProductCtrl',
                    controllerAs: 'ProductCtrl'
                }).state('compare', {
                    url: '/:category_code/compare/?pid&current',
                    templateProvider: () => {
                        return import('@app/pages/compare/comparePageView.html').then(t => t.default);
                    },
                    controller: 'ComparePageCtrl',
                    controllerAs: 'ComparePageCtrl',
                    data: {
                        pageType: 'comparePage',
                    },
                    resolve: {
                        activeCategory: ['CategoriesService', getActiveCategory],
                        lazyLoad: ['$ocLazyLoad', function ($ocLazyLoad) {
                            return import(/* webpackChunkName: 'index' */ '@app/pages/compare/comparePageModule')
                                .then(function (mod) {
                                    return $ocLazyLoad.inject(mod.name);
                                })
                                .catch(function (err) {
                                    throw new Error(`Module Import Error: ${err}`);
                                });
                        }],
                    }
                }).state('categories', {
                    url: '/categories/:category_code/',
                    templateProvider: () => {
                        return import('@app/pages/categoryLandingPage/categoryLandingPageView.html').then(t => t.default);
                    },
                    controller: 'CategoryLandingPageCtrl',
                    controllerAs: 'CategoryLandingPageCtrl',
                    data: {
                        pageType: 'categoryLandingPage',
                    },
                    resolve: {
                         lazyLoad: ['$ocLazyLoad', function ($ocLazyLoad) {
                            return import(/* webpackChunkName: 'index' */ '@app/pages/categoryLandingPage/categoryLandingPageModule')
                                .then(function (mod) {
                                    return $ocLazyLoad.inject(mod.name);
                                })
                                .catch(function (err) {
                                    throw new Error(`Module Import Error: ${err}`);
                                });
                        }],
                    }
                }).state('auth', {
                    url: '/account/auth/?next&params&project_type',
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'other' */ '@app/components/account/accountAuth/accountAuthView.html').then(t => t.default);
                    },
                    controller: 'AccountAuthCtrl',
                    controllerAs: 'AccountAuthCtrl',
                    data: {
                        pageType: 'authPage',
                    },
                    resolve: {
                        activeCategory: ['CategoriesService', getActiveCategory],
                        lazyLoad: lazyLoadOtherModule
                    }
                }).state('account', {
                    url: '/account/settings/?' + UTM_TRACKING_PARAMETERS,
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'other' */ '@app/components/account/accountSettings/accountView.html').then(t => t.default);
                    },
                    controller: 'AccountCtrl',
                    controllerAs: 'AccountCtrl',
                    data: {
                        pageType: 'accountPage',
                    },
                    resolve: {
                        accountInfo: ['AccountService',
                            function (AccountService) {
                                return AccountService.getLoggedInUserProfile();
                            }
                        ],
                        activeCategory: ['CategoriesService', getActiveCategory],
                        addresses: ['accountInfo', '$q', 'AccountSettingsService', 'UtilService',
                            function (accountInfo, $q, AccountSettingsService, UtilService) {
                                var isProfileAddressEnabled = UtilService.isFeatureEnabled('profile_address');
                                if (isProfileAddressEnabled) {
                                    return AccountSettingsService.getAddressInfo();
                                } else {
                                    $q.resolve({});
                                }
                            }
                        ],
                        lazyLoad: lazyLoadOtherModule,
                    }
                }).state('reset-password',  {
                    url: '/account/auth/reset-password/?resetToken&userId&nextUrl',
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'other' */ '@app/components/account/accountAuth/accountAuthSetNewPassword.html').then(t => t.default);
                    },
                    controller: 'AccountAuthCtrl',
                    controllerAs: 'AccountAuthCtrl',
                    data: {
                        pageType: 'authPage',
                    },
                    resolve: {
                        activeCategory: ['CategoriesService', getActiveCategory],
                        lazyLoad: lazyLoadOtherModule,
                    }

                }).state('verify-email', {
                    url: '/account/auth/verify-email/?key',
                    controller: ['$q',
                                 '$stateParams',
                                 '$timeout',
                                 'AccountAuthService',
                                 'IndexService',
                                 '$state',
                                 'CmsContentService',
                        function ($q,
                                  $stateParams,
                                  $timeout,
                                  AccountAuthService,
                                  IndexService,
                                  $state,
                                  CmsContentService) {

                            var verifiedKey = 'account_page:alerts:email_verified';
                            var unverifiedKey = 'account_page:alerts:email_cannot_be_verified';
                            function getAlertMessage() {
                                return $q.all({
                                    verified: CmsContentService.getMarketPlaceText(verifiedKey).then(function (text) {
                                        return {
                                            type: "success",
                                            message: text,
                                        };
                                    }),
                                    unverified: CmsContentService.getMarketPlaceText(unverifiedKey).then(function (text) {
                                        return {
                                            type: "error",
                                            message: text
                                        };
                                    }),
                                });
                            }
                            AccountAuthService.verifyEmailAccount($stateParams.key).then(function (registeredUser) {
                                var isEmailActivated = registeredUser && registeredUser.activated;
                                var isAuthenticated = AccountAuthService.isAuthenticated();
                                var alert;
                                getAlertMessage().then(function (_message) {
                                    alert = _message;
                                    return getCurrentUserInfo();
                                }).then(function (_currentUser) {
                                    var _registeredEmail = registeredUser.emailAddress;
                                    if (isEmailActivated) {
                                        alert = alert.verified;

                                    } else {
                                        alert = alert.unverified;
                                    }

                                    if (isAuthenticated && _currentUser.email !== _registeredEmail) {
                                        AccountAuthService.logout().then(function () {
                                            setAlertWithClear(alert);
                                            $state.go('auth', { reload: true });
                                        });
                                    } else if (isAuthenticated && _currentUser.email === _registeredEmail) {
                                        setAlertWithClear(alert);
                                        $state.go('email-settings', { reload: true });
                                    } else if (!isAuthenticated) {
                                        setAlertWithClear(alert);
                                        $state.go('auth', {reload: true});
                                    }
                                });
                            }, function () {
                                // If verifying the account fails
                                getAlertMessage().then(function (_message) {
                                    return setAlertWithClear(_message.unverified);
                                });

                                $state.go('auth', {reload: true});
                            });

                            function setAlertWithClear(alert) {
                                IndexService.setHeaderAlerts([alert]);
                                $timeout(IndexService.clearHeaderAlerts, 1000);
                            }

                            function getCurrentUserInfo() {
                                return AccountAuthService.checkIfUserLoggedIn().then(function (response) {
                                    if (response.is_authenticated) {
                                        return AccountAuthService.fetchCurrentUserInfo().then(function () {
                                            return AccountAuthService.getCurrentUser();
                                        });
                                    }
                                    return $q.resolve({});
                                });
                            }
                        }
                    ]
                }).state('auth.enter-password', {
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'other' */ '@app/components/account/accountAuth/accountAuthEnterPasswordView.html').then(t => t.default);
                    },
                    data: {
                        pageType: 'authPage',
                    },
                    resolve: resolveOtherModule,
                }).state('auth.create-password', {
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'other' */ '@app/components/account/accountAuth/accountAuthCreatePasswordView.html').then(t => t.default);
                    },
                    data: {
                        pageType: 'authPage',
                    },
                    resolve: resolveOtherModule,
                }).state('auth.forgot-password', {
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'other' */ '@app/components/account/accountAuth/accountAuthForgotPasswordView.html').then(t => t.default);
                    },
                    data: {
                        pageType: 'authPage',
                    },
                    resolve: resolveOtherModule,
                }).state('auth.forgot-password-sent-modal', {
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'other' */ '@app/shared/modals/resetPasswordLink/passwordResetSent.html').then(t => t.default);
                    },
                    data: {
                        pageType: 'authPage',
                    },
                    resolve: resolveOtherModule,
                }).state('auth.reset-password-success', {
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'other' */ '@app/components/account/accountAuth/accountAuthPasswordResetLogin.html').then(t => t.default);
                    },
                    data: {
                        pageType: 'authPage',
                    },
                    resolve: resolveOtherModule,
                }).state('auth.welcome-back', {
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'other' */ '@app/components/account/accountAuth/accountAuthResetPasswordLink.html').then(t => t.default);
                    },
                    data: {
                        pageType: 'authPage',
                    },
                    resolve: resolveOtherModule,
                }).state('fav-products', {
                    url: '/account/fav-products/' + sortByParam + "&" + UTM_TRACKING_PARAMETERS,
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'other' */ '@app/components/account/accountFavProducts/favProductsView.html').then(t => t.default);
                    },
                    controller: 'FavProductsCtrl',
                    controllerAs: 'FavProductsCtrl',
                    data: {
                        pageType: 'favoriteProductsPage',
                    },
                    resolve: {
                        activeCategory: ['CategoriesService', getActiveCategory],
                        /**
                         * Gets translated sort options
                         */
                        translatedSortCodes: ['$q', 'CmsContentService', 'UtilService', 'activeCategory', getTranslatedSortCodes],
                        lazyLoad: lazyLoadOtherModule,
                    }
                }).state('my-searches', {
                    url: '/account/my-searches/?' + UTM_TRACKING_PARAMETERS,
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'other' */ '@app/components/account/accountMySearches/mySearchesView.html').then(t => t.default);
                    },
                    controller: 'MySearchesCtrl',
                    controllerAs: 'MySearchesCtrl',
                    data: {
                        pageType: 'accountPage',
                    },
                    resolve: {
                        mySearches: ['SavedSearchesService',
                            function (SavedSearchesService) {
                                return SavedSearchesService.fetchSavedSearches().then(function () {
                                    return SavedSearchesService.getSavedSearches();
                                });
                            }
                        ],
                        lazyLoad: lazyLoadOtherModule,
                    }
                }).state('email-settings', {
                    url: '/account/email-settings/?' + UTM_TRACKING_PARAMETERS,
                    templateProvider: () => {
                        return import(/* webpackChunkName: 'other' */ '@app/components/account/accountEmailSettings/emailSettingsView.html').then(t => t.default);
                    },
                    controller: 'EmailSettingsCtrl',
                    controllerAs: 'EmailSettingsCtrl',
                    data: {
                        pageType: 'accountPage',
                    },
                    resolve: {
                        emailSettings: ['EmailSettingsService',
                            function (EmailSettingsService) {
                                return EmailSettingsService.fetchEmailSubscriptionInfo().then(function () {
                                    return EmailSettingsService.getEmailSubscriptionInfo();
                                });
                            }
                        ],
                        lazyLoad: lazyLoadOtherModule,
                    }
                }).state('flat-pages', {
                    url: '/*path/?{section:any}&{pid:any}&{category:any}&{name:any}&{featuredpid:any}&' + UTM_TRACKING_PARAMETERS,
                    template: require('@utils/flatPage/flatPageView.html'),
                    controller: 'FlatPageCtrl',
                    controllerAs: 'FlatPageCtrl',
                    data: {
                        pageType: 'flatPage',
                    },
                    resolve: {
                        flatPages: ['$q', 'FlatPageService',
                            function ($q, FlatPageService) {
                                return FlatPageService.getKnownFlatPages();
                            }
                        ],
                        flatPageData: ['$q', '$stateParams', '$location', 'FlatPageService', 'flatPages', 'EnerveeCheckoutService', 'CartAnalyticsService',
                            function ($q, $stateParams, $location, FlatPageService, flatPages, EnerveeCheckoutService, CartAnalyticsService) {
                                var defer = $q.defer();

                                /**
                                 * Takes a flat page id and queries wagtail for the flat page matching the id.
                                 * If no content is found for the given id, we redirect to error page.
                                 * @param id
                                 */
                                function getWagtailContent (id) {
                                    FlatPageService.fetchWagtailContent(id).then(function () {
                                        var content = FlatPageService.getWagtailContent();
                                        if (content === false) {
                                            // the content wasn't found for the given id. error.
                                            defer.reject({redirectTo: '404'});
                                        }
                                        defer.resolve(content);
                                    });
                                }

                                if ($stateParams.path) {
                                    var path = '/' + $stateParams.path;
                                    var pathWithTrailingSlash = null;

                                    if (path[path.length - 1] !== '/') {
                                        pathWithTrailingSlash = path + '/';
                                    }
                                    if (path in flatPages) {
                                        // this is a valid path. let's try to get the content from wagtail
                                        getWagtailContent(flatPages[path]);
                                    } else if (pathWithTrailingSlash !== null && pathWithTrailingSlash in flatPages) {
                                        // this is also a valid path. let's try to get the content from wagtail
                                        getWagtailContent(flatPages[pathWithTrailingSlash]);
                                    } else {
                                        // this isn't a valid path. error.
                                        defer.reject({redirectTo: '404'});
                                    }

                                }

                                EnerveeCheckoutService.initializeCartFromURL().then(function (products) {
                                    if (products.length > 0) {
                                        CartAnalyticsService.reportEvent('Cart Engaged', {
                                            location: 'mainContent',
                                            type_of_change: 'Add Product',
                                            source: 'url param'
                                        }, products);
                                    }
                                });

                                return defer.promise;
                            }
                        ],
                        lazyLoad: lazyLoadOtherModule,
                    }
                }).state('flat-pages-missing-slash', {
                    // This is the redirect for missing a trailing slash.
                    url: '/*path',
                    controller: ['$location', '$stateParams', function ($location, $stateParams) {
                        $location.url('/' + $stateParams.path + '/');
                    }],
                    data: {
                        pageType: 'flatPage',
                    },
                    resolve: resolveOtherModule,
                });


        }]
    );

})(angular);
